<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.99902 4L9.99902 4V2L3.99902 2C2.89445 2 1.99902 2.89445 1.99902 3.99902L1.99902 15.999C1.99902 17.1036 2.89445 17.999 3.99902 17.999L15.999 18C17.1036 18 17.999 17.1046 17.999 16L17.999 9H15.999L15.999 16L3.99902 16L3.99902 4Z"
    fill="currentColor"
  />
  <path
    d="M14.8995 3.41422L15.6066 2.70711C15.9971 2.31658 16.6303 2.31658 17.0208 2.70711C17.4113 3.09763 17.4113 3.7308 17.0208 4.12132L16.3137 4.82843L14.8995 3.41422Z"
    fill="currentColor"
  />
  <path
    d="M15.6066 5.53554L8.384 12.7581L5.70709 14.0208L6.96978 11.3439L14.1924 4.12132L15.6066 5.53554Z"
    fill="currentColor"
  />
</svg>
